import { createContext } from 'react';

export const NotificationsContext = createContext({
  isLoading: false,
  notifications: [],
  unreadCount: 0,
  lastUpdate: Date.now(),
  // eslint-disable-next-line no-console
  addNotification: () => console.warn('addNotification not implemented'),
  setNotificationsOnRead: () => {
    // eslint-disable-next-line no-console
    console.warn('setNotificationsOnRead not implemented');
  },
});
